var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		_vm.$s.Container,
		_vm.$s[("shape_" + _vm.shapeInner)],
		_vm.$s[("size_" + _vm.sizeInner)] ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }